import React from 'react';
import CardListItem from './CardListItem';
import { format } from 'date-fns';
import StatusBadge from './StatusBadge';
import TableRowElement from './TableRowElement';
import getSubmissionStatusLabel from '@dashboard/services/status/getSubmissionStatusLabel';

export default function SubmissionListItem({ submission, options = {} }) {
  const isCompact = options.appearance === 'compact';

  return (
    <CardListItem href={`/submissions/${submission._id}`} key={submission._id}>
      <TableRowElement size={isCompact ? 'xl' : '3xl'}>
        <div className="font-medium">
          {submission.customerEmail || submission.billing?.email || ''}
        </div>
        <div className="text-sm text-gray-500">
          {submission.customerName || submission.billing?.name || ''}
        </div>
      </TableRowElement>

      {!options.hidePageName && (
        <TableRowElement size={isCompact ? 'xl' : '4xl'} className="font-medium">
          {submission.page.name}
        </TableRowElement>
      )}

      <TableRowElement align="right" size="xl">
        {format(new Date(submission.createdAt), 'd MMM, yyyy, HH:mm')}
      </TableRowElement>

      {!options.hideStatus && (
        <TableRowElement size={isCompact ? 'small' : 'medium'}>
          {submission.livemode ? (
            <StatusBadge
              status={submission.status}
              label={getSubmissionStatusLabel(submission.status)}
            />
          ) : (
            <StatusBadge status="test" label="Test" />
          )}
        </TableRowElement>
      )}
    </CardListItem>
  );
}
